import { createApp } from 'vue'
import App from './App.vue'
import i18n from '@/i18n'

document.title = i18n.global.t('title')

const app = createApp(App)
app.use(i18n)
app.mount('#gb-webrtc')
